import { render, staticRenderFns } from "./global-snack.vue?vue&type=template&id=7491c156&scoped=true&"
import script from "./global-snack.vue?vue&type=script&lang=js&"
export * from "./global-snack.vue?vue&type=script&lang=js&"
import style0 from "./global-snack.vue?vue&type=style&index=0&id=7491c156&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7491c156",
  null
  
)

export default component.exports